import React from "react";

import SVGnumber from "./../components/SVGnumber";
import { Link } from "react-router-dom";

import "../styles/components/SectionHistory.css";

const urlAddress = new Map([
  ["short", "/oferta/wynajem-krotkookresowy"],
  ["long", "/oferta/wynajem-dlugookresowy"],
  ["sell", "/oferta/sprzedaz"],
  ["fleet", "/oferta/obsluga-flot"]
]);

const getAddress = url => {
  const splitUrl = url.split("/");
  const getUrlFromMap = urlAddress.get(splitUrl[splitUrl.length - 2]);
  return getUrlFromMap ? getUrlFromMap : "/oferta";
};

const SectionBenefits = ({ data, dataButton }) => {
  return (
    <div className="container container-small section-car-text">
      <div className="row">
        {data.map &&
          data.map((history, idx) => {
            return (
              <div className="col-12 col-md-4 section-car-text_element" key={idx}>
                <SVGnumber version={idx + 1} />
                <div dangerouslySetInnerHTML={{ __html: history.desc }} />
              </div>
            );
          })}
        <div className="col-12 col-md-4 section-car-text_element">
          {dataButton ? (
            <Link className="btn-general btn-general--primary" to={getAddress(dataButton.url)}>
              {dataButton.title ? dataButton.title : "Czytaj więcej"}
            </Link>
          ) : (
            <Link className="btn-general btn-general--primary" to={"/oferta"}>
              Czytaj więcej
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionBenefits;
